// extracted by mini-css-extract-plugin
export default {"searchTextEditor":"AttributeSearch_searchTextEditor__0HvEN","searchRelativeDataEditor":"AttributeSearch_searchRelativeDataEditor__j28S7"};